import { FC } from "react";
import Restricted from "@/consumer/restricted";
import { Collapse, ListItem } from "@mui/material";
import {
  NavigationIconCustomConfigs,
  NavigationItemButton,
  NavigationListItemContent,
  NavigationNavLink,
} from "@/components/navigation/navigationItems";
import "@/components/navigation/navigationBar.css";
import styles from "@/components/navigation/adminRoutes.module.css";
import { useTranslation } from "react-i18next";

interface Route {
  path: string;
  name: string;
  icon: string;
  index: number;
  permission?: string;
  iconCustomConfigs?: NavigationIconCustomConfigs;
}

interface GenericNavigationCollapseProps {
  routesToRender: Route[];
  drawerOpen: boolean;
  selectedIndex: number;
  subRouteOpen: any;
  handleListSoubrouteItemClick: (event: any, subrouteIndex: number) => void;
  subRouteKey: string;
}

const GenericNavigationCollapse: FC<GenericNavigationCollapseProps> = ({
  routesToRender,
  drawerOpen,
  selectedIndex,
  subRouteOpen,
  handleListSoubrouteItemClick,
  subRouteKey,
}) => {
  const { t } = useTranslation();
  return (
    <Collapse
      in={subRouteOpen[subRouteKey]}
      timeout="auto"
      unmountOnExit
      className={styles.collapse}
      component={"ul"}
    >
      {routesToRender.map((subroute: any) => {
        const subrouteListItem = (
          <ListItem
            disablePadding
            className={drawerOpen ? "navigationItemOpen" : "navigationItem"}
            key={subroute.name}
          >
            <NavigationNavLink to={subroute.path}>
              <NavigationItemButton
                drawerOpen={drawerOpen}
                onClick={(event: any) =>
                  handleListSoubrouteItemClick(event, subroute.index)
                }
                selected={selectedIndex === subroute.index}
                pl={1}
              >
                <NavigationListItemContent
                  drawerOpen={drawerOpen}
                  primaryText={t(subroute.name)}
                  icon={subroute.icon}
                  iconCustomConfigs={subroute.iconCustomConfigs}
                />
              </NavigationItemButton>
            </NavigationNavLink>
          </ListItem>
        );

        if (subroute.permission) {
          return (
            <Restricted
              key={subroute.name + "_restriction"}
              permissionRequired={subroute.permission}
            >
              {subrouteListItem}
            </Restricted>
          );
        }

        return subrouteListItem;
      })}
    </Collapse>
  );
};

export default GenericNavigationCollapse;
